import type { AgentUsageClient } from "@common/schemas/domains/agentRuns/agent-usage.schema";

export interface AgentUsageRow extends AgentUsageClient {
    id: string;
    name: string;
    iconColor: string | null;
}

interface UsageWorkspace {
    id: string;
    name: string;
    iconColor: string | null;
}

interface ToAgentUsageRowsParams {
    clients: readonly AgentUsageClient[];
    workspaces: readonly UsageWorkspace[];
}

/** The usage rows for the clients the viewer can see, in the server's order. */
export function toAgentUsageRows({
    clients,
    workspaces,
}: ToAgentUsageRowsParams): AgentUsageRow[] {
    const workspacesById = new Map(
        workspaces.map((workspace) => [workspace.id, workspace]),
    );
    return clients.flatMap((client) => {
        const workspace = workspacesById.get(client.workspaceId);
        return workspace
            ? [
                  {
                      ...client,
                      id: client.workspaceId,
                      name: workspace.name,
                      iconColor: workspace.iconColor,
                  },
              ]
            : [];
    });
}

export function filterUsageRows(
    rows: readonly AgentUsageRow[],
    search: string | undefined,
): AgentUsageRow[] {
    const needle = search?.trim().toLowerCase();
    if (!needle) {
        return [...rows];
    }
    return rows.filter((row) => row.name.toLowerCase().includes(needle));
}
